import { useEffect, useRef, useState } from 'react';
import type { SidePopupProps } from '../store/types';
import CloseBtn from './icons/CloseBtn';

const CLOSE_ANIMATION_FALLBACK_MS = 1200;

const SidePopup = ({ active: activeProp, closeSidebar, children, screenName }: SidePopupProps) => {
    const [shouldRenderChildren, setShouldRenderChildren] = useState<boolean>(activeProp);
    const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const sidePopupRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const popupElement = sidePopupRef.current;
        const clearCloseTimeout = () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
            }
        };

        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }

        if (activeProp) {
            setShouldRenderChildren(true);
            clearCloseTimeout();
            return;
        }

        if (!popupElement) {
            setShouldRenderChildren(false);
            return;
        }

        const handleTransitionEnd = (event: TransitionEvent) => {
            if (event.target !== popupElement) return;
            if (event.propertyName !== 'transform' && event.propertyName !== '-webkit-transform') return;
            clearCloseTimeout();
            setShouldRenderChildren(false);
        };

        popupElement.addEventListener('transitionend', handleTransitionEnd);

        closeTimeoutRef.current = setTimeout(() => {
            setShouldRenderChildren(false);
            closeTimeoutRef.current = null;
        }, CLOSE_ANIMATION_FALLBACK_MS);

        return () => {
            clearCloseTimeout();
            popupElement.removeEventListener('transitionend', handleTransitionEnd);
        };
    }, [activeProp]);

    useEffect(() => {
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            <div className={`bg-linear linear-${screenName} ${(activeProp ? ' show ' : ' ')} `} />
            <div ref={sidePopupRef} className={"side_popup  " + (activeProp ? ' show ' : ' ')} >
                <div className="container-fluid fh-100 ">
                    <div className="row fh-100 ">
                        {shouldRenderChildren ? children : null}
            
                    </div>
                </div>
                <div>
                    <CloseBtn togglePopup={() => {
                        closeSidebar();
                    }} black={true} />
                </div>
                
            </div>
        </>
    );
};

export default SidePopup;
